/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import * as Actions from '../../actions/actions';
import { withStyles } from '@mui/styles';
import { FormGroup } from '@mui/material';
import { useLocale } from '../../languages/LocaleProvider';
import { withUser } from '../../UserProvider';

function UserInterfaceComponent(props) {
	const [themeName, setThemeName] = useState(
		localStorage.getItem('theme') ? localStorage.getItem('theme') : 'Default'
	);
	const { locale, setLocale } = useLocale();

	const handleLanguageChange = (event) => {
		const newLocale = event.target.value;
		const settings = { locale: newLocale };
		setLocale(newLocale);
		props.saveUserSettings(props.userId, settings);
	};

	const handleThemeChange = (event) => {
		setThemeName(event.target.value);
		localStorage.setItem('theme', event.target.value);
		// props.openPage('/settings') TODO recreate theme
		location.reload();
	};

	return (
		<div
			style={{
				marginLeft: '20px',
				marginTop: '20px'
			}}
		>
			<FormGroup>
				<TextField
					variant="outlined"
					size="small"
					select
					margin="normal"
					value={locale}
					onChange={(event) => handleLanguageChange(event)}
					label={<FormattedMessage id="UserInterface.Language" defaultMessage="Language" />}
				>
					<MenuItem value="en">
						<FormattedMessage id="UserInterface.English" defaultMessage="English" />
					</MenuItem>
					<MenuItem value="de">
						<FormattedMessage id="UserInterface.German" defaultMessage="German" />
					</MenuItem>
				</TextField>
				<TextField
					id="theme-selection"
					value={themeName}
					select
					margin="normal"
					variant="outlined"
					size="small"
					onChange={(event) => handleThemeChange(event)}
					inputProps={{
						name: 'theme-selection',
						id: 'theme-selection'
					}}
					label={<FormattedMessage id="UserInterface.Theme" defaultMessage="Theme" />}
				>
					<MenuItem value="Default">
						<FormattedMessage id="UserInterface.Default" defaultMessage="Default" />
					</MenuItem>
					<MenuItem value="Dark">
						<FormattedMessage id="UserInterface.Dark" defaultMessage="Dark" />
					</MenuItem>
					<MenuItem value="Light">
						<FormattedMessage id="UserInterface.Light" defaultMessage="Light" />
					</MenuItem>
				</TextField>
			</FormGroup>
		</div>
	);
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Actions, dispatch);
}

export const UserInterface = withUser(({ user }) => ({ userId: user.id }))(
	connect(null, mapDispatchToProps)(withStyles({}, { withTheme: true })(UserInterfaceComponent))
);
